module.exports = __webpack_public_path__ + "media/images/political-commitment-photo-cover-338018828af6a777f0676b8f68fd0842.jpg";